import { useState } from "react";

import { Specimen } from "pwapi";

import { CaseDetailState } from "shared/reducers/caseDetailReducer";

import Sidebar from "./Sidebar";
import SpecimenDialog, { shouldShowSpecimenDialog } from "./SpecimenDialog";
import SpecimenDialogEditForm from "./SpecimenDialogEditForm";

export type SpecimenDialogProps = {
  specimen: Specimen;
  caseDetail?: CaseDetailState;
};

const SpecimenDialogController = ({
  specimen,
  caseDetail,
}: SpecimenDialogProps) => {
  const [editingSpecimen, setEditingSpecimen] = useState<boolean>(false);

  const showSpecimenDialog = shouldShowSpecimenDialog(specimen);

  return showSpecimenDialog ? (
    <Sidebar isScrollable isWide={editingSpecimen}>
      <div className="Sidebar__contentContainer">
        {editingSpecimen ? (
          <SpecimenDialogEditForm
            specimen={specimen}
            caseDetail={caseDetail}
            onClose={() => setEditingSpecimen(false)}
          />
        ) : (
          <SpecimenDialog
            specimen={specimen}
            onEdit={() => setEditingSpecimen(true)}
            caseDetail={caseDetail}
          />
        )}
      </div>
    </Sidebar>
  ) : null;
};

export default SpecimenDialogController;
